<button
  type="button"
  class="maxx-trigger"
  [id]="triggerId"
  [class.maxx-trigger--filled]="hasAnalysis"
  [class.maxx-trigger--loading]="state.status === 'loading'"
  [attr.aria-label]="tooltip"
  [attr.aria-expanded]="hasAnalysis ? state.expanded : null"
  [attr.aria-controls]="state.expanded ? panelId : null"
  [matTooltip]="tooltip"
  matTooltipClass="pdq-mat-tooltip"
  matTooltipPosition="above"
  (click)="triggerClick.emit($event)">
  @if (state.status === 'loading') {
    <pdq-spinner [small]="true"></pdq-spinner>
  } @else {
    <svg
      class="maxx-trigger__icon"
      viewBox="0 0 105.556 80"
      fill="currentColor"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M95.7466 0H21.3674C16.6548 0 12.6061 3.35051 11.7245 7.97385L0.17687 68.3383C-0.976802 74.3868 3.65965 80 9.81983 80H84.199C88.9117 80 92.9604 76.6494 93.842 72.0261L105.379 11.6725C106.532 5.62413 101.896 0.0108891 95.7357 0.0108891L95.7466 0ZM77.7776 41.6209C70.3876 43.6769 65.762 46.0375 62.2901 49.4969C58.84 52.9562 56.4782 57.5795 54.4103 64.9769C54.16 65.8798 53.409 66.2062 52.7887 66.2062C52.1683 66.2062 51.4173 65.8798 51.167 64.9769C49.11 57.5904 46.7482 52.9671 43.2872 49.4969C39.8262 46.0484 35.2006 43.6878 27.7997 41.6209C26.8963 41.3707 26.5698 40.62 26.5698 40C26.5698 39.3799 26.8963 38.6293 27.7997 38.3791C35.1897 36.3231 39.8153 33.9625 43.2872 30.5031C46.7373 27.0438 49.0991 22.4205 51.167 15.0231C51.4173 14.1202 52.1683 13.7939 52.7887 13.7939C53.409 13.7939 54.16 14.1202 54.4103 15.0231C56.4674 22.4096 58.84 27.0438 62.2901 30.5031C65.7511 33.9516 70.3767 36.3122 77.7776 38.3791C78.681 38.6293 79.0075 39.3799 79.0075 40C79.0075 40.62 78.681 41.3707 77.7776 41.6209Z" />
    </svg>
  }
</button>
